import React, { useCallback } from 'react'

import { I18n, TimerSinceComponent } from '@front/volcanion'

import { Box, Typography, Icon, IconButton } from '@mui/material'
import moment from 'moment'

const TimerComponent = ({ startTime }) => {
  const mutator = useCallback(() => moment(startTime).fromNow(), [startTime])
  return (
    <Typography color='grey'>
      <TimerSinceComponent startTime={startTime} mutator={mutator} />
    </Typography>
  )
}

const IconLabel = ({ label, _label, icon, _icon }) => !!label && (
  <Box display='flex' flexDirection='row' alignItems='center' gap={1}>
    <Icon className='material-symbols-rounded' {..._icon}>{icon}</Icon>
    <Typography {..._label}>{label}</Typography>
  </Box>
)

const Short = ({
  producer_usertype,
  producedAt,
  incident_name,
  driver_label,
  vehicle_label,
  requestedAt_label,
  comment_label,
  b2b_label,
  user_label,
  handleClose,
  onSelect
}) => (
  <Box onClick={onSelect} display='flex' flexDirection='column' bgcolor='background.default' width={550} p={1} borderRadius={2} gap={1} boxShadow={6} position='relative' sx={{ cursor: 'pointer' }}>
    <IconButton
      size='small'
      onClick={handleClose}
      sx={{
        position: 'absolute',
        top: -10,
        left: -10,
        bgcolor: 'background.paper',
        color: 'text.primary',
        width: 24,
        height: 24,
        boxShadow: 2,
        '&:hover': { bgcolor: 'grey.100' }
      }}
    >
      <Icon sx={{ fontSize: 16 }}>close</Icon>
    </IconButton>

    <Box display='flex' flexDirection='row' justifyContent='space-between'>
      <IconLabel
        label={I18n.t(`toast.incident.short.type.${producer_usertype}`)}
        _label={{ color: 'grey' }}
        icon='warning'
        _icon={{ color: 'error' }}
      />
      <TimerComponent startTime={producedAt} />
    </Box>

    <Typography fontWeight='bold'>{I18n.t(`incident.${incident_name}`, { count: 1 })}</Typography>

    {(!!driver_label || !!vehicle_label) && (
      <Box display='flex' flexDirection='row' justifyContent='space-between'>
        <IconLabel label={driver_label} icon='search_hands_free' />
        <IconLabel label={vehicle_label} icon='local_taxi' />
      </Box>
    )}

    {(!!requestedAt_label || !!b2b_label) && (
      <Box display='flex' flexDirection='row' justifyContent='space-between'>
        <IconLabel label={requestedAt_label} icon='calendar_month' />
        <IconLabel label={b2b_label} icon='work' />
      </Box>
    )}

    {!!comment_label && (
      <Box display='flex' flexDirection='row'>
        <IconLabel label={comment_label} icon='comment' />
      </Box>
    )}

    {!!user_label && (
      <Box display='flex' flexDirection='row'>
        <IconLabel label={user_label} icon='person' />
      </Box>
    )}

  </Box>
)

export default Short
